export const notifications = (state) => state.displayedMessages
